import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';

import {
  openRecurringOrderEditModal,
  closeRecurringOrderDetailModal,
} from 'redux/modules/recurring-orders/effects';

import { getRecurringOrder } from 'redux/modules/recurring-orders/selectors';

import { Modal } from '@ontruck/orc';

import Header from './Header';
import Content from './Content';

import RecurringOrderEditModal from 'modules/recurring-orders/EditModal';

class RecurringOrderDetail extends PureComponent {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
  }

  handleClose() {
    const { closeDetailModal, history } = this.props;
    closeDetailModal({ history });
  }

  handleEditClick() {
    const { openEditModal, match } = this.props;
    const id = match.params.id;

    openEditModal({ id });
  }

  render() {
    const { match, recurringOrder } = this.props;
    const id = match.params.id;

    return (
      <Fragment>
        <Modal
          show={true}
          onClose={this.handleClose}
          size="XL"
          headerComponent={
            <Header onEditOrderClick={this.handleEditClick} recurringOrder={recurringOrder} />
          }
          subHeaderComponent={null}
        >
          <Content id={id} />
        </Modal>
        <Route
          exact
          path={`${match.url}/edit`}
          render={(props) => <RecurringOrderEditModal id={id} />}
        />
      </Fragment>
    );
  }
}

RecurringOrderDetail.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.any.isRequired,
  recurringOrder: PropTypes.any.isRequired,
  closeDetailModal: PropTypes.func.isRequired,
  openEditModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  closeDetailModal: closeRecurringOrderDetailModal,
  openEditModal: openRecurringOrderEditModal,
};

const mapStateToProps = (state) => ({
  recurringOrder: getRecurringOrder(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecurringOrderDetail));
